import { money, pct, num, negClass } from './format'

function Tile({ label, value, sub, highlight, valueClass = '' }) {
  return (
    <div className={[
      'rounded-xl border px-3.5 py-3',
      highlight ? 'border-emerald-200 bg-emerald-50' : 'border-slate-200 bg-white',
    ].join(' ')}>
      <div className="text-xs text-slate-500">{label}</div>
      <div className={`text-[21px] font-semibold mt-1 tabular-nums ${valueClass}`}>{value}</div>
      <div className="text-[11.5px] text-slate-500 mt-0.5">{sub}</div>
    </div>
  )
}

/** The six headline tiles, from statement.kpis (the current column). */
export default function KpiTiles({ kpis, periodLabel, loading }) {
  if (loading && !kpis) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-2.5 mb-4">
        {[0, 1, 2, 3, 4, 5].map((i) => <div key={i} className="skeleton h-[78px] rounded-xl" />)}
      </div>
    )
  }
  const k = kpis || {}
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-2.5 mb-4" aria-label={`Key figures, ${periodLabel || ''}`}>
      <Tile label="Revenue" value={money(k.revenue)} sub="ex-GST" />
      <Tile
        label="Gross profit"
        value={money(k.gross_profit)}
        valueClass={negClass(k.gross_profit)}
        sub={`${pct(k.gross_margin)} margin`}
      />
      <Tile label="Wages & super" value={money(k.wages_super)} sub="from Xero" />
      <Tile label="Overheads" value={money(k.overheads)} sub="from Xero" />
      <Tile
        label="PBIT"
        value={money(k.pbit)}
        valueClass={negClass(k.pbit)}
        sub={`${pct(k.pbit_margin)} of revenue`}
        highlight
      />
      <Tile
        label="PBIT per order"
        value={money(k.pbit_per_order, 2)}
        valueClass={negClass(k.pbit_per_order)}
        sub={`${num(k.orders)} orders`}
      />
    </div>
  )
}
